// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"3daa8f2d","269":"c037708a","273":"1c99b841","348":"a7c5c78f","476":"dfea3325","639":"9712b8a1","918":"88503e58","965":"03493cba"}[chunkId] + ".chunk.js";
};